import {
  getEmptyTransformRuleGroup,
  getEmptyTransformRuleItem,
} from '@components/data-transform-panel/utils/initializeUtils';
import { EInputType } from '@components/mapping-panel/components/RuleBuilder/KeyValueBuilder/typed';
import { ITransformRule } from '@src/common/types/empTypes';
import { EStringOp } from '@src/emp-3.0/types';

export const trimTransformRules = (transformRule: ITransformRule[]) => {
  const res = transformRule.filter((andTransformGroup) => {
    return (
      andTransformGroup.source_dimension ||
      (andTransformGroup.rule ?? []).filter(
        (subAndTransformItems) =>
          subAndTransformItems.filter((subOrTransformItem) => subOrTransformItem.value?.length > 0)
            .length !== 0,
      ).length !== 0
    );
  });
  if (res.length === 0) {
    res.push(getEmptyTransformRuleGroup());
  }
  return res;
};

export const updateTransformRules = (
  transformRule: ITransformRule[],
  orIndex: number,
  subAndIndex: number,
  subOrIndex: number,
  type: EInputType,
  value: string,
) => {
  const ruleGroup = transformRule?.[orIndex];
  const ruleItem = ruleGroup.rule?.[subAndIndex]?.[subOrIndex];
  switch (type) {
    case EInputType.METADATA_NAME:
      ruleGroup.source_dimension = value;
      break;
    case EInputType.METADATA_OPERATOR:
      if (ruleItem?.op !== undefined) ruleItem.op = value as EStringOp;
      break;
    case EInputType.METADATA_VALUE:
      if (ruleItem?.value !== undefined) ruleItem.value = [value];
      break;
    default:
      break;
  }
  return transformRule;
};

export const deleteTransformMetadataGroup = (transformRule: ITransformRule[], orIndex: number) => {
  transformRule.splice(orIndex, 1);
  if (transformRule.length === 0) {
    transformRule.push(getEmptyTransformRuleGroup());
  }
  return transformRule;
};

export const deleteTransformMetadataItem = (
  transformRule: ITransformRule[],
  orIndex: number,
  subAndIndex: number,
  subOrIndex: number,
) => {
  const targetTransformMetadataGroup = transformRule[orIndex];
  targetTransformMetadataGroup.rule[subAndIndex].splice(subOrIndex, 1);
  if (targetTransformMetadataGroup.rule[subAndIndex].length === 0) {
    targetTransformMetadataGroup.rule.splice(subAndIndex, 1);
  }
  if (targetTransformMetadataGroup.rule.length === 0) {
    targetTransformMetadataGroup.rule.push([getEmptyTransformRuleItem()]);
  }
  return transformRule;
};

export const addTransformMetadataGroup = (transformRule: ITransformRule[]) => {
  transformRule.push(getEmptyTransformRuleGroup());
  return transformRule;
};

export const addAndTransformMetadataItem = (transformRule: ITransformRule[], orIndex: number) => {
  transformRule[orIndex].rule.push([getEmptyTransformRuleItem()]);
  return transformRule;
};

export const addOrTransformMetadataItem = (transformRule: ITransformRule[], orIndex: number) => {
  const l = transformRule[orIndex].rule.length;
  if (l === 0) {
    transformRule[orIndex].rule.push([getEmptyTransformRuleItem()]);
  } else {
    transformRule[orIndex].rule[l - 1].push(getEmptyTransformRuleItem());
  }
  return transformRule;
};

export const updateTransformMetadataByLogicOperator = (
  transformRule: ITransformRule[],
  orIndex: number,
  subAndIndex: number,
  subOrIndex?: number,
) => {
  if (subOrIndex === undefined) {
    // Switching the logical operator "AND" to "OR" updates the rules.
    const andRules = transformRule[orIndex].rule.splice(subAndIndex, 1);
    transformRule[orIndex].rule[subAndIndex - 1].push(...andRules[0]);
  } else {
    // Switching the logical operator "OR" to "AND" updates the rules.
    const newAndRules = transformRule[orIndex].rule[subAndIndex].splice(subOrIndex);
    transformRule[orIndex].rule.splice(subAndIndex + 1, 0, newAndRules);
  }
  return transformRule;
};

export const transformRenameRulesToState = (transformRule?: ITransformRule[]) => {
  if (!transformRule) {
    return [getEmptyTransformRuleGroup()];
  }
  transformRule.forEach((orTransform) => {
    if (!orTransform.rule || orTransform.rule.length === 0) {
      orTransform.rule = [[getEmptyTransformRuleItem()]];
    }
  });
  return transformRule;
};
